<template>
  <div id="app" class="d-flex justify-content-center flex-column">
    <Loader v-if="$store.getters.loading" />
    <Navbar />
    <div class="app-body">
      <router-view />
    </div>
    <Footer />
    <div id="snackbar" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Loader from "@/components/Loader.vue";
import Footer from "@/components/Footer.vue";
import $ from "jquery";

export default {
  name: "app",
  components: {
    Navbar,
    Loader,
    Footer
  },
  beforeCreate() {
    document.title = "Special Data";
  },
  data() {
    return {
      loadingCount: 0
    };
  },
  mounted() {
    $("body").on("hidden.bs.modal", function() {
      if ($(".modal:visible").length) {
        $("body").addClass("modal-open");
      }
    });
  },
  methods: {
    startLoading() {
      this.loadingCount++;
    },
    doneLoading() {
      if (this.loadingCount > 0) {
        this.loadingCount--;
      } else {
        this.loadingCount = 0;
      }
    }
  }
};
</script>

<style>
html,
body {
  height: 100%;
}

.alert-header {
  background-color: rgb(255, 79, 79);
}

.hzPin {
  display: none !important;
}

#app {
  font-family: "Geneva", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 100%;
  min-height: 100vh;
}

.app-body {
  width: 100%;
  flex: 1;
}

#app .spedTitle {
  color: #01596f;
  font-weight: bold;
}

#app .spedSubtitle {
  color: #01596f;
}

#app .btn.btn-primary {
  background-color: #3b9ad0;
  border-color: #3b9ad0;
}

#app .btn.btn-primary:hover {
  background-color: #187db8;
  border-color: #187db8;
}

#app .btn.btn-outline-primary.active {
  background-color: #3b9ad0;
  border-color: #3b9ad0;
  color: #fff;
}

#app .btn.btn-outline-primary {
  color: #3b9ad0;
  border-color: #3b9ad0;
}

#app .btn.btn-outline-primary:hover {
  color: #fff;
  border-color: #3b9ad0;
  background-color: #3b9ad0;
}

#app .btn.btn-link {
  color: #3b9ad0;
}
#app .btn-link {
  color: #3b9ad0;
}
#app .text-info {
  color: #3b9ad0 !important;
}
#app .text-primary {
  color: #3b9ad0 !important;
}
#app .bg-info {
  background-color: #3b9ad0 !important;
}
#app a {
  color: #3b9ad0;
}

#app .pointer {
  cursor: pointer;
}
#app .container {
  padding-top: 0.5rem;
}

/*#app .btn.btn-primary {
  background-color: rgb(0, 143, 136);
  color: white;
  border-color: rgb(0, 143, 136);
}*/

#app .applet {
  text-align: left;
  padding: 1rem;
  background-color: rgba(1, 89, 111, 0.1);
}

#app .separatorLine {
  width: 100%;
  background-color: gray;
  height: 1px;
  margin-bottom: 0.5rem;
}

#app .input-error {
  border-color: rgba(255, 79, 79, 0.637);
  box-shadow: 0 0 5px rgb(255, 79, 79);
}
#app .input-success {
  border-color: rgba(50, 179, 50, 0.637);
  box-shadow: 0 0 5px rgb(50, 179, 50);
}

#app .underlined {
  border-bottom: gray;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

#snackbar {
  visibility: hidden;
  min-width: 400px;
  max-width: 400px;
  margin-left: -200px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 8px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  top: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

#snackbar.long-show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 5.5s;
  animation: fadein 0.5s, fadeout 0.5s 5.5s;
}

@-webkit-keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

#app .form-group {
  text-align: left;
}

#app .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
#app .fade-enter,
#app .fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.hidden {
  visibility: hidden;
}

.modal-dialog {
  margin-top: 4em;
}

.circle { 
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  padding: 0.5rem;
}
</style>
